// nuolino-admin/src/auth/AuthContext.ts
// Context isolado. Separado de AuthProvider.tsx para fast-refresh limpo.

import { createContext } from 'react';
import type { AuthContextValue } from './AuthProvider';

export const AuthContext = createContext<AuthContextValue | null>(null);
